import React from "react";
import { CONSTANTS } from "../../constants/Constants";
import { handleDragEnter, handleDragStart } from "../../utils/helpers";

interface TableProps {
  tableHeader: string[];
  tableRows: {}[];
  dragEndHandler?: () => void;
  dragItem?: any;
  draggable?: boolean
  dragOverItem?: any;
  rowClickHandler?: (index: number) => void;
}

const Table: React.FC<TableProps> = ({
  tableHeader,
  tableRows,
  dragEndHandler,
  dragItem,
  dragOverItem,
  draggable = true,
  rowClickHandler,
}) => {
  return (
    <table className="w-full border-collapse border border-gray-300">
      <thead>
        <tr className="bg-gray-100">
          {draggable && <th></th>}
          {tableHeader.map(
            (header, index) =>
              header !== "id" && (
                <th key={header + index} className="py-2 px-3 text-left text-gray-500">
                  {header}
                </th>
              )
          )}
        </tr>
      </thead>
      <tbody>
        {tableRows.length > 0 ? (
          tableRows.map((row: any, index) => (
            <tr
              key={row.id || `row-${index}`}
              draggable={draggable}
              onDragStart={() => handleDragStart(index, dragItem)}
              onDragEnter={() => handleDragEnter(index, dragOverItem)}
              onDragEnd={dragEndHandler}
              className="border-b cursor-pointer border-gray-300 hover:bg-gray-50"
              onClick={rowClickHandler ? () => rowClickHandler(index) : () => {}}
            >
              {draggable && (
                <td className="text-center py-2 px-3 cursor-grab">
                  <span className="text-gray-500 mr-2">☰</span>
                </td>
              )}
              {Object.keys(row).map((key, idx) =>
                key === "imageUrl" ? (
                  <td key={`${row.id}-${key}-${idx}`} className="py-4 w-[100px] h-24 translate-x-1">
                    {row[key] ? 
                      <img
                        src={row[key]}
                        alt=""
                        className="w-16 h-16 object-contain"
                      /> : ""
                    }
                  </td>
                ) : key === "mediaFile" || key === "imageFile" ? (
                  <td key={`${row.id}-${key}-${idx}`} className="p-4">
                    {row[key]?.name}
                  </td>
                ) : key !== "status" ? (
                  <td key={`${row.id}-${key}-${idx}`} className="p-4 max-w-72 truncate">
                    {row[key]}
                  </td>
                ) : (
                  <td key={`${row.id}-${key}-${idx}`} className="py-2 px-3">
                    <span
                      className={`px-3 py-1 text-sm rounded ${
                        row[key]?.toLocaleLowerCase() === "enabled"
                          ? "bg-green-200 text-green-800"
                          : "bg-gray-200 text-gray-800"
                      }`}
                    >
                      {row[key]?.toLocaleUpperCase() === "ENABLED" ? CONSTANTS.YES_TXT : CONSTANTS.NO_TXT}
                    </span>
                  </td>
                )
              )}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={tableHeader.length} className="p-5 text-center">
              {CONSTANTS.NO_DATA_AVAILABLE}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default Table;
